import flatpickr from 'flatpickr';
import { German } from 'flatpickr/dist/l10n/de.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';

import { mMenu } from '../metronic/framework/components/general/menu';
import { mPortlet } from '../metronic/framework/components/general/portlet';
import { formClassNames, formHooks } from './formClassNames';
import {
    getCsrfToken,
    hideButtonShowLoader,
    insertAlert,
    isNotSupported,
    jq,
    parseJson,
    replaceUrlParameters,
    setBorderBrandColorForCheckedRadio,
    showButtonHideLoader,
} from './helpers';

const locales = { nl: Dutch, fr: French, de: German };

export function initializeGeneralEventListeners() {
    // if a shown modal has an input with autofocus, focus on it
    $(document).on('shown.bs.modal', '.modal', function () {
        $(this).find('input[autofocus]').focus();
    });

    /*
        if modal has data-form-url find a form inside the modal, and set the form action to data-form-url, where
        url parameters are replaced with data from the element that was clicked to show the modal
    */
    $(document).on('show.bs.modal', '.modal[data-form-url]', function (event) {
        if (this.dataset.formUrl === '') {
            return;
        }
        var url = replaceUrlParameters(
            this.dataset.formUrl,
            event.relatedTarget.dataset,
        );

        $(this).find('form').attr('action', url);
    });

    // filter property type select on properties.edit
    $(document).on('change', '#property-type-select', function (event) {
        filterPropertyTypeSelect(event.target.value);
    });

    // filter property type select on properties.edit
    $(document).ready(function () {
        if (document.querySelector('#property-type-select')) {
            filterPropertyTypeSelect(
                document.querySelector('#property-type-select').value,
            );
        }
    });

    // set correct text on delete-component-scope-modal
    $(document).on(
        'show.bs.modal',
        '#delete-component-scope-modal',
        function (event) {
            var number = parseInt(event.relatedTarget.dataset.componentCount);
            var modal_body = this.querySelector('.modal-body');

            if (number > 0) {
                insertAlert(
                    lang.choice(
                        'activities.delete_component_scope_warning',
                        number,
                        { number: number },
                    ),
                    modal_body,
                );
            }
        },
    );

    // set correct input for role and subject when showing remove_role_modal
    $(document).on('show.bs.modal', '#remove_role_modal', function (event) {
        let role_id = event.relatedTarget.dataset.roleId || '';
        let subject_id = event.relatedTarget.dataset.subjectId || '';
        let user_id = event.relatedTarget.dataset.userId || '';
        let form = this.querySelector('form');

        document.getElementById(
            'remove_role_modal_role_table_body',
        ).textContent = '';

        form.querySelectorAll('input[type="hidden"][name$="_id"]').forEach(
            (e) => e.remove(),
        );

        [
            { name: 'role_id', value: role_id },
            { name: 'subject_id', value: subject_id },
            { name: 'user_id', value: user_id },
        ].forEach(function (input) {
            let hidden_input = document.createElement('input');
            hidden_input.setAttribute('name', input.name);
            hidden_input.setAttribute('value', input.value);
            hidden_input.setAttribute('type', 'hidden');
            form.appendChild(hidden_input);
        });

        let role_table_row = document.importNode(
            event.relatedTarget.parentElement.parentElement,
            true,
        );

        while (role_table_row.lastChild.tagName !== 'TD') {
            role_table_row.removeChild(role_table_row.lastChild);
        }

        role_table_row.removeChild(role_table_row.lastChild);
        document
            .getElementById('remove_role_modal_role_table_body')
            .appendChild(role_table_row);
    });

    // set correct text on send_wavemessage_modal
    $(document).on(
        'show.bs.modal',
        '#send_wavemessage_modal',
        function (event) {
            var type = event.relatedTarget.dataset.type;

            $('#modal-text').text(
                $('#modal-text').data('text').replace('__type__', type),
            );
        },
    );

    $(document).on('show.bs.modal', '.has-container-select', function (event) {
        let component_container_container = event.target.querySelector(
            '.react-component-container-select',
        );
        if (component_container_container === null) {
            // for template
            return;
        }
        if (component_container_container.children.length === 0) {
            // container select is not rendered yet

            import(
                '@/react/features/ContainerSelect/mountContainerSelect.js'
            ).then(({ renderSelect }) => {
                const tree_data = parseJson(
                    component_container_container.dataset.treeData,
                );
                renderSelect(component_container_container, tree_data);
            });
        }
    });

    // set correct content on delete_modal
    $(document).on('show.bs.modal', '.delete-modal', function (event) {
        let target = event.relatedTarget;
        let data = target.dataset;

        this.querySelector('.modal-title').textContent = lang.get(
            'general.title_delete',
            { type: data.type },
        );

        this.querySelector('.remove-modal-body').textContent = lang.get(
            'general.confirm_delete',
            { item: data.item },
        );

        let form = this.querySelector('form');
        let table = window[form.dataset.tableId];

        // if table is a datatable and rowId is set, we only want to delete that specific row, so we need
        // to deselect other rows, and select the row that is being deleted
        if (
            $.fn.dataTable &&
            table instanceof $.fn.dataTable.Api &&
            data.rowId
        ) {
            table
                .rows()
                .deselect()
                .row('#' + data.rowId)
                .select();
        }

        let datatable_selected_ids =
            window[form.dataset.tableId]?.datatable_selected_ids ?? [];

        let number = Math.max(data.number ?? datatable_selected_ids.length, 1);

        this.querySelector('.remove-modal-body')
            .closest('div')
            .querySelectorAll('.comment_element')
            .forEach((e) => e.remove());

        if (data.message) {
            var comment_element = document.createElement('p');
            comment_element.classList.add('comment_element');

            var message = lang.get(data.message, data);

            if (message.indexOf('|') > -1) {
                message = lang.choice(data.message, number, data);
            }

            comment_element.innerText = message;

            this.querySelector('.remove-modal-body')
                .closest('div')
                .appendChild(comment_element);
        }
    });

    // set correct content on remove_component_modal
    $(document).on(
        'show.bs.modal',
        '#confirm_component_removal_modal',
        function (event) {
            var data = event.relatedTarget.dataset;
            var modal = $(this);
            modal
                .find('#remove-component-from-batch')
                .attr('data-component-id', data.componentId);
        },
    );

    // if delete_working_day_modal is shown and working_day has appointments show warning text
    $(document).on(
        'show.bs.modal',
        '#delete_working_day_modal',
        function (event) {
            var appointments = parseInt(
                event.relatedTarget.dataset.appointments || 0,
            );

            $('#delete-with-appointments-text').html(
                lang.get('working_days.delete_appointments_1') +
                    ' ' +
                    lang.choice('working_days.appointment_s', appointments, {
                        appointments: appointments,
                    }) +
                    lang.get('working_days.delete_appointments_2', {
                        message: this.dataset.messageUrl,
                    }) +
                    '<div class="' +
                    formClassNames.formGroup +
                    '" ' +
                    formHooks.formGroup +
                    '><input type="text" class="' +
                    formClassNames.input +
                    '" name="reason" id="reason" placeholder="' +
                    lang.get('general.reason') +
                    '"></div>',
            );
        },
    );

    $(document).on('show.bs.modal', '#resend_message_modal', function (event) {
        const event_id = event.relatedTarget.dataset.id;

        document.querySelector(
            '#resend_message_form input[name="event_id"]',
        ).value = event_id;
    });

    // show only filename in file input
    $(document).on('change', 'input[type=file]', function () {
        $('label.custom-file-label[for=' + jq(this.id) + ']').text(
            this.value.split('\\').slice(-1)[0],
        );
    });

    /*
    focus on other text input, and make it required when clicking on corresponding other radio button,
    for properties or questions with options and option other
*/
    $(document).on('change click', '.other_radio', function () {
        var other_input = $(this).parent().next('.other_input');
        if (this.checked) {
            other_input.focus();
            other_input.attr('required', true);
        } else {
            other_input.attr('required', false);
        }
    });

    // set required false for other input text input when other option in option list is selected
    $(document).on('change click', '.has_option_other', function () {
        $(this)
            .parents('.m-radio-list')
            .find('.other_input')
            .attr('required', false);
    });

    // Show nested placeholders -> placeholders.blade.php
    $('.show_sub').on('click', function () {
        var key = this.dataset.id;
        var icon = this.querySelector('i');
        var placeholder_column = this.closest('.placeholders_column');

        placeholder_column
            .querySelectorAll('.' + key)
            .forEach((e) => e.classList.toggle('d-none'));
        icon.classList.toggle('la-plus');
        icon.classList.toggle('la-minus');
    });

    /*
    if a checkbox with class post-checkbox is changed, this change should be posted to a url that is in
    a post-checkbox-data element on the same page
*/
    $('.post-checkbox').on('change', function () {
        var post = {};
        var input = this;

        var checkbox_data = parseJson(
            document.querySelector('[data-selector="post-checkbox-data"]')
                .innerText,
        );

        if (checkbox_data === null) {
            return;
        }

        var update_checkbox_route =
            checkbox_data.update_checkbox_route instanceof Object
                ? checkbox_data.update_checkbox_route[this.dataset.updateRoute]
                : checkbox_data.update_checkbox_route;

        var url = replaceUrlParameters(update_checkbox_route, input.dataset);

        var location = input.dataset.savedIconLocation;

        var was_checked = !input.checked;

        post[input.getAttribute('name')] = input.checked ? '1' : '0';
        post['_token'] = getCsrfToken();

        // prevent overlapping writes that could complete out of order
        input.disabled = true;

        $.ajax({
            type: 'POST',
            url: url,
            data: post,
            success: function () {
                showAjaxResponseIcon(
                    input,
                    location,
                    'la-save',
                    'm--font-success',
                );
            },
            error: function (response) {
                showAjaxResponseIcon(
                    input,
                    location,
                    'la-exclamation-triangle',
                    'm--font-danger',
                    getPostCheckboxErrorMessage(response),
                );

                input.checked = was_checked;
            },
            complete: function () {
                input.disabled = false;
            },
        });
    });

    // show other add workstation_owner group when workstation_owner select is add
    $('#workstation_owner_user_id').on('change', function () {
        var user_id = this.value;
        if (user_id === 'other') {
            $('#new_workstation_owner_group').removeClass('d-none');
            document.getElementById('name').value = '';
            document.getElementById('name').required = true;
            document.getElementById('email').value = '';
            document.getElementById('email').required = true;
        } else {
            $('#new_workstation_owner_group').addClass('d-none');
            document.getElementById('name').value = '';
            document.getElementById('name').required = false;
            document.getElementById('email').value = '';
            document.getElementById('email').required = false;
        }
    });

    //set default choice on backend.component_choices.index
    $('.set-default-choice').on('change', function () {
        var input = this;
        var name = input.name.replace('choice_', '');
        var value = input.value;

        var set_default_data = parseJson(
            document.querySelector('[data-selector="set-default-data"]')
                .innerText,
        );

        if (set_default_data === null) {
            return;
        }

        var url = set_default_data.set_default_url;
        var token = getCsrfToken();

        $('div[data-parent-choice-id=' + name + ']')
            .find('.default-choice')
            .remove();

        $.post(replaceUrlParameters(url, { id: value }), {
            _token: token,
        })
            .done(function () {
                var span_default = document.createElement('span');
                span_default.className = 'default-choice';
                span_default.innerHTML =
                    ' (' + lang.get('choose.default_choice') + ')';
                input.parentNode.after(span_default);
                disableNotSelectedChoices(input);
            })
            .fail(function () {
                $('div[data-id=' + name + ']')
                    .find('input[type=radio]')
                    .prop('checked', false)
                    .prop('disabled', false);
            });
    });

    // display or hide component choice attributes on backend.forms.component_choice
    $('#component_choice_none').on('change', function () {
        if ($(this).prop('checked')) {
            $('#component-choice-component-properties input[required]')
                .addClass('required_input')
                .prop('required', false);
            $('#component-choice-component-properties').addClass('d-none');
        } else {
            $('#component-choice-component-properties .required_input')
                .removeClass('required_input')
                .prop('required', true);
            $('#component-choice-component-properties').removeClass('d-none');
        }
    });

    //  if component_choice_none is checked when loading backend.forms.component_choice don't require component inputs
    $(function () {
        if (!document.getElementById('component_choice_none')) {
            return;
        }

        if (document.getElementById('component_choice_none').checked) {
            $('#component-choice-component-properties input[required]')
                .addClass('required_input')
                .prop('required', false);
        }
    });

    // show resend_last_message_modal if last_message can be resend on backend.emailadress.edit
    $('#email_form').on('submit', function (event) {
        if ($('#resend_last_message_modal_form').length > 0) {
            event.preventDefault();
            var email = $('#email').val();
            $('<input>')
                .attr({ type: 'hidden', name: 'email', value: email })
                .appendTo($('#resend_last_message_modal_form'));
            $('#resend_last_message_modal').modal();
        }
    });

    // if document_type is for_signature show corresponding form part on backend.forms.document
    $('#document_type').on('change', function () {
        if ($(this).val() === 'for_signature') {
            $('.for_signature').removeClass('d-none');
        } else {
            $('.for_signature').addClass('d-none');
        }
    });

    // if add_email is clicked add another email input to form
    // is used on several routes where emails are prepared
    $('.add_email').on('click', function () {
        var subject = this.dataset.subject ? this.dataset.subject + '-' : '';

        $('#' + subject + 'document-emails')
            .append($('script[data-template="email"]').text())
            .find('input')
            .last()
            .focus();
    });

    // if remove-document-email is clicked remove email input from form on several routes where emails are prepared
    $('.email-address-container').on(
        'click',
        '.remove-document-email',
        function () {
            this.closest('.email-address-row').remove();
        },
    );

    // add option input when clicking add_property_option button on backend.properties.edit
    $('#add_property_option').on('click', function () {
        $('#property_options_group').append(
            $('script[data-template="option"]').text(),
        );
    });

    // remove option input when clicking remove button on backend.properties.edit
    $('#property_options_group').on('click', '.remove', function () {
        $(this).parents('.form-group').remove();
    });

    // on backend.schedule_appointment.create and enduser.schedule_appointment.show show modal when clicking on time_slot
    $('.schedule-appointment-link').on('click', function (event) {
        event.preventDefault();
        document.getElementById(
            'confirm-schedule-appointment-time-slot-id',
        ).value = this.dataset.timeSlotId;
        document.getElementById(
            'confirm-schedule-appointment-start',
        ).innerHTML = this.dataset.start;
        document.getElementById('confirm-schedule-appointment-end').innerHTML =
            this.dataset.end;
        document.getElementById('confirm-schedule-appointment-date').innerHTML =
            this.closest('.working-day-time-slots').querySelector(
                'h5',
            ).innerHTML;
    });

    // add text and input to remove_time_slot_modal in backend.working_days.show when time_slot has appointment
    $('.remove_time_slot').on('click', function () {
        if (this.getAttribute('data-appointment') === 'true') {
            $('#remove_time_slot_modal-body').append(
                '<div id="delete_time_slot">' +
                    lang.get('working_days.delete_time_slot') +
                    ' ' +
                    lang.choice('working_days.appointment_s', 1, {
                        appointments: 1,
                    }) +
                    ' ' +
                    lang.get('working_days.delete_appointments_2', {
                        message: document.getElementById(
                            'remove_time_slot_modal',
                        ).dataset.messageUrl,
                    }) +
                    '<div class="' +
                    formClassNames.formGroup +
                    '" ' +
                    formHooks.formGroup +
                    '><input type="text" class="' +
                    formClassNames.input +
                    '" name="reason" id="reason" placeholder="' +
                    lang.get('general.reason') +
                    '"></div></div>',
            );
        }
    });

    // remove text and input to remove_time_slot_modal in backend.working_days.show after hiding modal
    $('#remove_time_slot_modal').on('hidden.bs.modal', function () {
        $('#delete_time_slot').remove();
    });

    // if enduser appointment cannot be rescheduled show warning on enduser.wizard.workstations.index -> enduser.wizard.workstations.workstation_appointment
    $('.enduser_appointment_cancel').on('click', function (event) {
        event.preventDefault();
        if (event.target.dataset.reschedule_possible === 'false') {
            $('#modal-body').append(
                '<div class="m-alert--outline alert alert-danger" id="reschedule_not_possible">' +
                    lang.get('planning.reschedule_not_possible') +
                    '</div>',
            );
        }
    });

    // hide warning on enduser.wizard.workstations.index -> enduser.wizard.workstations.workstation_appointment
    $('#cancel_appointment_modal').on('hidden.bs.modal', function () {
        $('#reschedule_not_possible').remove();
    });

    // show warning when deleting default container
    $('#delete_component_container_modal').on(
        'show.bs.modal',
        function (event) {
            const target = event.relatedTarget;

            const default_warning = this.querySelector(
                '#delete-default-container-warning',
            );
            const warning_list = document.getElementById(
                'default-warning-list',
            );

            if (!target) {
                return;
            }

            const table = window[target.dataset.tableId];

            const selected_id = parseInt(target.dataset.id);
            const datatable_selected_ids = table?.datatable_selected_ids ?? [];

            if (datatable_selected_ids.length === 0 && selected_id) {
                table.row(target.closest('tr')).select();
            }

            const defaults =
                parseJson(
                    document.querySelector(
                        '[data-selector="project-default-containers"]',
                    )?.innerText ?? '',
                ) ?? {};

            let states = [];

            Object.keys(defaults).forEach(function (key) {
                if (datatable_selected_ids.includes(parseInt(defaults[key]))) {
                    states.push(key);
                }
            });

            if (!states.length) {
                default_warning.classList.add('d-none');
                return;
            }

            default_warning.classList.remove('d-none');

            if (warning_list) {
                warning_list.remove();
            }

            var list = document.createElement('ul');
            list.id = 'default-warning-list';

            states.forEach((state) => {
                var state_item = document.createElement('li');
                state_item.innerText = lang.get('component.' + state);
                list.appendChild(state_item);
            });

            default_warning.querySelector('.alert-text').appendChild(list);
        },
    );

    // if there is a success alert remove it with an animated effect -> layouts.master
    $(function () {
        $('#success-alert')
            .delay(3000)
            .slideUp(200, function () {
                $(this).alert('close');
            });
    });

    // show warning if using ie in backend
    $(function () {
        if (isNotSupported()) {
            $('#error-wrapper').append(
                '<div class="alert alert-danger" id="error-danger">' +
                    lang.get('activities.not_supported_browser') +
                    '</div>',
            );
        }
    });

    // show modal with error if error is thrown on backend.workstations.show
    $(function () {
        var error = document.getElementById('workstation_modal_error');

        if (!error) {
            return;
        }

        if (error.dataset.modal !== 'activity_failed') {
            $('#' + error.dataset.modal + '_modal').modal();
            return;
        }

        $('#error-wrapper').append(
            '<div class="alert alert-danger" id="error-danger">' +
                error.dataset.errorMessage +
                '</div>',
        );
    });

    // Keep enduser address form visibility/styling in sync.
    $(function () {
        let form = document.getElementById('enduser_change_address_form');

        if (!form) {
            return;
        }

        const sync_enduser_address_form = (with_border = false) => {
            import('@/app/addressLocation.js').then(
                ({ checkEnduserAddressForm }) => {
                    checkEnduserAddressForm();

                    if (with_border) {
                        setBorderBrandColorForCheckedRadio();
                    }
                },
            );
        };

        sync_enduser_address_form(true);

        $(document).on('change', '.enduser_address_choice', () => {
            sync_enduser_address_form();
        });
    });

    // show label outline when radio option changes
    $(document).on('change', '.m-option-radio-input', function () {
        setBorderBrandColorForCheckedRadio();
    });

    // dont show workstation checkboxes on template form if template type is not short term or long term
    $('#template_type').on('change', function () {
        $('#shipping_project').toggleClass(
            'd-none',
            this.value !== 'long_term',
        );

        if (this.value === 'long_term' || this.value === 'short_term') {
            $('#workstation_project_choices').removeClass('d-none');

            return;
        }

        $('#workstation_project_choices').addClass('d-none');
        $('#workstation_project_choices input[type=checkbox]').each(
            function (i, e) {
                e.checked = false;
            },
        );
    });

    // show documents select on forms.wizardstep if wizard_step_type is sign_document
    $('#wizard_step_type').on('change', function () {
        var document_select_group = document.getElementById(
            'wizard_step_document_select_form_group',
        );

        if (document_select_group === null) {
            return;
        }

        var select = document_select_group.querySelector('select');

        if (this.value === 'sign_document') {
            document_select_group.classList.remove('d-none');
            select.required = true;

            return;
        }

        document_select_group.classList.add('d-none');

        if (select) {
            select.value = '';
            select.required = false;
        }
    });

    $(document).on('click', '.printing-activity', function () {
        let form_data;
        let button = this;

        let must_redirect = this.getAttribute('data-must-redirect') === 'true';
        let redirect_url = this.getAttribute('data-redirect-url');

        let document_url = this.getAttribute('data-document-url');
        let method = this.getAttribute('data-method') || 'GET';

        if (method === 'POST') {
            form_data = new FormData();
            form_data.append('_token', getCsrfToken());
        }

        import('@/support/printScript.js').then(
            ({ temporaryDisableButton, setRedirect, printPdf }) => {
                temporaryDisableButton(button);
                setRedirect(must_redirect, redirect_url);
                printPdf(document_url, method, form_data || null);
            },
        );
    });

    // remove iframe and property_list after hiding modal on component_containers.index and component_containers.show
    $('#container_properties_modal').on('hidden.bs.modal', function () {
        $('#print_iframe').remove();
        $('#property_list').empty();
    });

    // show container modal on component_containers.index and component_containers.show
    $(document).on('click', '.show-cover-content-properties', function () {
        var url = this.getAttribute('data-properties-url');
        var component_container_id = this.getAttribute(
            'data-component-container-id',
        );

        import('@/support/componentContainer.js').then((module) =>
            module.showCoverContentPropertiesModal(url, component_container_id),
        );
    });

    $(document).on('click', '.toggle-favourite', function () {
        var button = this;
        if (button.dataset.loading === 'true') {
            return;
        }

        button.dataset.loading = 'true';
        button.setAttribute('disabled', true);

        var post = {};

        var url = this.dataset.url;
        var icon = $(this).find('.la-star');

        post['_token'] = getCsrfToken();
        post['component_containers'] = [this.dataset.componentContainerId];

        $.ajax({
            type: 'POST',
            url: url,
            data: post,
            success: function () {
                icon.toggleClass('text-warning text-muted');
            },
            error: function () {
                showAjaxResponseIcon(
                    icon[0],
                    'append',
                    'la-exclamation-triangle',
                    'm--font-danger',
                );
            },
            complete: function () {
                button.dataset.loading = 'false';
                button.removeAttribute('disabled');
            },
        });
    });

    // enable/disable component choices on backend.choose_components.create
    $(document).on('change', '.component-choice-input', function () {
        disableNotSelectedChoices(this);
    });

    // enable/disable shopware choice in client settings
    if (document.querySelector('#enable_shopware')) {
        document
            .querySelector('#enable_shopware')
            .addEventListener('change', function () {
                toggleShopwareFields();
                document
                    .querySelector('.shopware-warning')
                    .classList.toggle('d-none', this.checked);
            });
    }

    // Enable/disable delete secondary email field section in client settings
    const secondaryEmailCheckbox = document.querySelector(
        '#enable_user_secondary_email_address',
    );
    const deleteSecondaryEmailSection = document.querySelector(
        '.delete_secondary_email_field_section',
    );
    const deleteSecondaryEmailCheckbox = document.querySelector(
        '#delete_secondary_email_address_if_unused',
    );

    if (secondaryEmailCheckbox && deleteSecondaryEmailSection) {
        const updateDeleteSecondaryEmailSectionVisibility = () => {
            const is_enabled = secondaryEmailCheckbox.checked;

            deleteSecondaryEmailSection.classList.toggle('d-none', !is_enabled);

            if (!is_enabled && deleteSecondaryEmailCheckbox) {
                deleteSecondaryEmailCheckbox.checked = false;
            }
        };

        secondaryEmailCheckbox.addEventListener(
            'change',
            updateDeleteSecondaryEmailSectionVisibility,
        );

        // Set initial visibility on page load
        updateDeleteSecondaryEmailSectionVisibility();
    }

    // hide form buttons and show loader instead when submitting form
    document.querySelectorAll('form.hide-buttons-on-submit').forEach((form) => {
        const hide_buttons = getElementToHideButtonsIn(form);

        form.addEventListener('submit', () => {
            hideButtonShowLoader(hide_buttons);
        });
    });

    window.addEventListener('pageshow', (event) => {
        if (!event.persisted) {
            // page was not loaded from cache
            return;
        }

        document
            .querySelectorAll('form.hide-buttons-on-submit')
            .forEach((form) => {
                const hide_buttons = getElementToHideButtonsIn(form);

                showButtonHideLoader(hide_buttons);
            });
    });

    $(document).on(
        'show.bs.modal',
        '.mass-move-to-container-modal',
        function () {
            resetNewContainerInputs();
        },
    );

    // upload attachment on projectmessage.edit and wavemessage.edit
    $('#attachment-form').on('submit', function (event) {
        event.preventDefault();

        if (document.getElementById('attachment').files.length > 0) {
            import('@/app/attachment.js').then(({ uploadAttachment }) => {
                uploadAttachment();
            });
        }
    });

    // delete attachment on projectmessage.edit and wavemessage.edit
    $(document).on('submit', '.delete-attachment', function (event) {
        event.preventDefault();

        import('@/app/attachment.js').then(({ destroyAttachment }) => {
            destroyAttachment($(this));
        });
    });

    // update question options on backend.forms.question.edit
    $(document).on('change', '#question-type-select', function () {
        const $select = $('#question-type-select');
        const $options = $('#options');
        const $otherGroup = $('#other_group');
        const $optionsTable = $('#options_table > tbody');
        const selectedType = $select.val();

        const showOptions = () => {
            $options.show();
            if ($optionsTable.children().length === 0) {
                $optionsTable.append(
                    $('script[data-template="option"]').text(),
                );
            }
        };

        const hideOptions = () => {
            $options.hide();
            $optionsTable.children().remove();
        };

        switch (selectedType) {
            case 'dropdown':
            case 'radio':
                showOptions();
                $otherGroup.show();
                break;
            case 'checkbox':
                showOptions();
                $otherGroup.hide();
                break;
            case 'yesno':
                hideOptions();
                $otherGroup.show();
                break;
            default:
                hideOptions();
                $otherGroup.hide();
        }
    });

    // show warning if option is focused on backend.forms.question.edit
    $(document).on('focus', '.question-option', function () {
        document
            .getElementById('edit_option_warning')
            .classList.remove('d-none');
    });

    // add new option on backend.forms.question.edit
    $('#add_answer_option').on('click', function () {
        var count = document.querySelectorAll('.new_option').length;
        var option = $('script[data-template="option"]')
            .text()
            .replaceAll('__new__', count);

        $('#options_table > tbody').append(option);
    });

    // remove option on backend.forms.question.edit
    $(document).on('click', '.remove-question-option', function () {
        $(this).parents('tr').remove();
    });

    $(document).on('click', '.add_property_button', function () {
        var subject = this.getAttribute('data-subject');

        $(
            '.add_property_button_form[data-subject=' + subject + ']',
        ).toggleClass('d-none');

        $('.add_property_form[data-subject=' + subject + ']').toggleClass(
            'd-none',
        );

        document.getElementById('add_property_input_' + subject).value = '';
        document.getElementById('add_property_input_' + subject).focus();
    });

    $(document).on('click', '.submit_property_button', function () {
        var subject = this.getAttribute('data-subject');

        import('@/app/addProperty.js').then(({ addProperty }) => {
            addProperty(subject);
        });
    });

    $(document).on('keydown', '.add_property_input', function (event) {
        if (event.key == 'Enter') {
            event.preventDefault();

            var subject = event.target.getAttribute('data-subject');

            import('@/app/addProperty.js').then(({ addProperty }) => {
                addProperty(subject);
            });
        }
    });

    $('.autocomplete[data-service-url]').each(function () {
        var autocomplete_input = this;

        import('@/app/autocomplete.js').then(({ setAutocomplete }) => {
            setAutocomplete(autocomplete_input);
        });
    });

    $('input:radio.inventory-answer,select.inventory-answer').on(
        'change',
        function () {
            if (this.value === '-1') {
                $('#' + this.name + '_text_group').show();
                $('#' + this.name + '_text').attr('required', true);
            } else {
                $('#' + this.name + '_text_group').hide();
                $('#' + this.name + '_text').attr('required', false);
            }
        },
    );

    // show help on enduser pages
    $(document).on('click', '.show-help', function () {
        $('.help[data-help-id="' + this.dataset.id + '_help"]').toggle();
    });

    // on enduser pages, remove required attribute from all input fields when clicking cancel button
    $('.dont-require').on('click', function () {
        $(':input').attr('required', false);
    });

    $(document).on('click', '.input-to-textarea-button', function () {
        import('@/app/formProperties').then(({ toggleInputToTextarea }) => {
            toggleInputToTextarea(this);
        });
    });

    $(document).on(
        'click',
        '#invoiced_activities_table .select_row',
        function () {
            const $row = $(this).closest('tr');
            const $inputs = $row.find('input[type="text"]');
            const isChecked = $(this).is(':checked');

            $inputs.prop('disabled', !isChecked);
        },
    );

    $(document).on('click', '.clear-radio-input', function () {
        var subject = this.dataset.subject;
        var property = this.dataset.property;
        var name = subject ? subject + '[' + property + ']' : property;

        document
            .querySelectorAll('input[type="radio"][name="' + name + '"]')
            .forEach((input) => (input.checked = false));

        var input_other = document.querySelector(
            'input[type="text"][name="' + name.replace(']', '_other]') + '"]',
        );

        if (input_other) {
            input_other.required = false;
        }
    });

    if (document.querySelector('.react-modal-opener')) {
        import('@/react/features/ReactModal/modalOpener.js').then(
            ({ initModalOpener }) => initModalOpener(),
        );
    }
}

export function checkOptionalEventListeners() {
    if (document.getElementById('breadcrumb_menu')) {
        new mMenu('breadcrumb_menu', {
            submenu: {
                desktop: 'dropdown',
            },
            dropdown: {
                timeout: 200, // timeout in milliseconds to show and hide the hoverable submenu dropdown
            },
        });
    }

    // Show client style color when hover over reset button
    if (document.getElementById('remove_project_style')) {
        document
            .getElementById('remove_project_style')
            .addEventListener('mouseover', function () {
                this.style.backgroundColor = this.dataset.clientColor;
            });

        document
            .getElementById('remove_project_style')
            .addEventListener('mouseout', function () {
                this.style.backgroundColor = null;
            });
    }

    if (document.getElementById('shipping_label_portlet')) {
        new mPortlet('shipping_label_portlet').on('beforeExpand', () => {
            var image = document.getElementById('shipping_label_image');

            if (image.src) {
                return;
            }

            var xhr = new XMLHttpRequest();
            var url = image.dataset.imageContentUrl;

            xhr.open('GET', url, true);
            xhr.send();

            xhr.onload = () => {
                if (xhr.status !== 200) {
                    return;
                }

                document
                    .getElementById('shipping_label_spinner')
                    .classList.add('d-none');

                image.src += 'data:image/png;base64,' + xhr.response;
            };
        });
    }

    document.querySelectorAll('form.is_printing_form').forEach((form) => {
        form.addEventListener('submit', (event) => {
            const form_data = new FormData(form);
            const must_redirect = form.dataset.mustRedirect === 'true';
            const redirect_url = form.dataset.redirectUrl;
            const modal = form.closest('.modal');

            event.preventDefault();

            import('@/support/printScript.js').then(
                ({ setModal, showModalLoader, setRedirect, printPdf }) => {
                    setModal(modal);
                    showModalLoader();
                    setRedirect(must_redirect, redirect_url);
                    printPdf(form.action, form.method, form_data);
                },
            );
        });
    });

    if (
        document.getElementById('target_component_container_id') &&
        document.getElementById('receiver_address_id')
    ) {
        $('#receiver_address_id').on('change', function () {
            let receiver_address = document.getElementById(
                'receiver_address_id',
            );

            let selectedOption =
                receiver_address.options[receiver_address.selectedIndex];
            let default_container_id = selectedOption
                ? selectedOption.dataset.defaultContainerId ?? null
                : null;

            let target_component_container_input = document.getElementById(
                'target_component_container_id',
            );
            target_component_container_input.value = default_container_id ?? '';

            target_component_container_input.dispatchEvent(
                new Event('hiddenContainerInputChanged'),
            );
        });
    }

    // if document contains selector with container options find react container select and render react container select component
    if (document.querySelector('.react-component-container-select')) {
        import('@/react/features/ContainerSelect/mountContainerSelect.js').then(
            ({ renderSelect }) => {
                document
                    .querySelectorAll('.react-component-container-select')
                    .forEach((mount_node) => {
                        if (mount_node.dataset.treeDataUrl) {
                            return;
                        }

                        const tree_data = JSON.parse(
                            mount_node.dataset.treeData || '[{}]',
                        );

                        renderSelect(mount_node, tree_data);
                    });
            },
        );
    }

    // add help text in backend.forms.move_workstation_setting.blade
    if (document.getElementById('move_workstation_setting_interval')) {
        showMoveWorkstationSettingHelpText(
            document.getElementById('move_workstation_setting_interval'),
        );

        document
            .getElementById('move_workstation_setting_interval')
            .addEventListener('change', function () {
                showMoveWorkstationSettingHelpText(this);
            });
    }

    if (document.querySelector('#sign_form #send_packing_list')) {
        let form = document.getElementById('sign_form');

        form.querySelector('#send_packing_list').addEventListener(
            'change',
            function () {
                form.querySelector('#email').required = this.checked;
            },
        );
    }

    if (document.getElementById('add_container_cancel')) {
        document
            .getElementById('add_container_cancel')
            .addEventListener('click', function () {
                resetNewContainerInputs();
            });
    }

    if (document.getElementById('add_container_button')) {
        var add_container_button_element = document.getElementById(
            'add_container_button',
        );
        var component_container_select_input = add_container_button_element
            .closest('form')
            .querySelector('.component-container-select-input');

        component_container_select_input.addEventListener(
            'containerSelectChanged',
            () =>
                setTimeout(
                    () =>
                        setNewContainerParentFeedback(
                            add_container_button_element,
                        ),
                    250,
                ),
        );

        add_container_button_element.addEventListener('click', function () {
            document.getElementById('container_name').required = true;
            document.getElementById('office_address_id').required = true;

            document
                .getElementById('container-select-new-container')
                .classList.remove('d-none');
            document
                .getElementById('add_container_cancel')
                .classList.remove('d-none');

            add_container_button_element.classList.add('d-none');

            setNewContainerParentFeedback(add_container_button_element);
        });
    }

    if (document.querySelector('.react-container')) {
        import('@/react/bootstrap/mount.jsx').then(({ mountReactComponents }) =>
            mountReactComponents(),
        );
    }

    document.querySelectorAll('.date-time-property-input').forEach((input) => {
        flatpickr(input, {
            allowInput: true,
            locale: locales[document.documentElement.lang] ?? locales['nl'],
        });
    });

    if (document.querySelectorAll('input.unique_property_input').length > 0) {
        import('@/app/formProperties').then(({ cleanQRCode }) => {
            document
                .querySelectorAll('input.unique_property_input')
                .forEach((input) => {
                    input.addEventListener('input', (event) => {
                        cleanQRCode(event.target);
                    });
                });
        });
    }

    // show arrows to previous and next workstation if workstation ids found in localStorage
    if (document.querySelector('meta[name="scrollable_ids_key"]')) {
        import('@/support/subheaderPaginator.js').then(({ showPaginator }) => {
            showPaginator();
        });
    }

    document
        .querySelectorAll('input.component_choice_number')
        .forEach((form) => {
            form.addEventListener('input', (event) => {
                var input = event.target;
                var choice_id = input.id.substr(input.id.lastIndexOf('_') + 1);

                document
                    .querySelectorAll(
                        'input[type="radio"][name^="option_' +
                            choice_id +
                            '["]',
                    )
                    .forEach((radio) => {
                        radio.required = input.value > 0;
                    });
            });
        });

    if (document.getElementById('login-redirect-body')) {
        redirectFromLogin();
    }

    // Enable/Disable shopware in client settings onload state
    if (document.querySelector('#enable_shopware')) {
        toggleShopwareFields();
    }

    // initialize assigned activities when one of the following elements is found
    if (
        document.querySelector(
            '.select-components-activity,.activity-modal-host,.perform_activity,.activity_failed',
        )
    ) {
        import('@/support/assignedActivities.js').then(
            ({ initializeAssignedActivities }) => {
                initializeAssignedActivities();
            },
        );
    }

    if (document.getElementById('add-component-to-batch-activity-store-form')) {
        import('@/support/batchActivities.js').then(
            ({ initializeBatchActivities }) => {
                initializeBatchActivities();
            },
        );
    }

    if (document.getElementById('component-inventory-content')) {
        import('@/support/componentInventory.js').then(
            ({ initializeComponentInventory }) => {
                initializeComponentInventory();
            },
        );
    }

    if (document.querySelector('[data-selector="choose-components-data"]')) {
        import('@/support/chooseComponents.js').then(
            ({ initializeChooseComponents }) => {
                initializeChooseComponents();
            },
        );
    }

    if (
        document.querySelector(
            '.component-select-js-modal, .component-select-js-form, .component-select-js-button',
        )
    ) {
        import('@/support/componentSelect.js').then(
            ({ initializeComponentSelect }) => {
                initializeComponentSelect();
            },
        );
    }

    if (document.getElementById('packing_list_add_component_form')) {
        import('@/support/packingList.js').then(({ initializePackingList }) => {
            initializePackingList();
        });
    }

    if (document.querySelector('.report_form_control')) {
        import('@/support/report.js').then(({ initializeReport }) => {
            initializeReport();
        });
    }

    if (document.getElementById('validate_choice_form')) {
        import('@/support/validateChoice.js').then(
            ({ initializeValidateChoice }) => {
                initializeValidateChoice();
            },
        );
    }

    if (
        document.querySelector(
            '#move_to_project_id,' +
                ' #add_workstations_to_activity_list_modal',
        )
    ) {
        import('@/support/workstationSelect.js').then(
            ({ initializeWorkstationSelect }) => {
                initializeWorkstationSelect();
            },
        );
    }

    if (document.querySelector('#add_shipments_to_activity_list_modal')) {
        import('@/support/shipmentSelect.js').then(
            ({ initializeShipmentSelect }) => {
                initializeShipmentSelect();
            },
        );
    }

    if (document.querySelector('#add_appointments_to_activity_list_modal')) {
        import('@/support/appointmentSelect.js').then(
            ({ initializeAppointmentSelect }) => {
                initializeAppointmentSelect();
            },
        );
    }

    if (document.querySelector('[data-selector="log-viewer"]')) {
        import('@/support/logviewer.js').then(({ initializeLogViewer }) => {
            initializeLogViewer();
        });
    }

    if (document.querySelector('.sortable')) {
        import('@/app/sortables.js').then(({ createSortables }) => {
            createSortables();
        });
    }

    if (document.getElementById('list_inventory_component_table')) {
        import('@/app/inventoryHelpers.js').then(
            ({ initializeListInventory }) => {
                initializeListInventory();
            },
        );
    }

    if (document.getElementById('questions_form')) {
        import('@/app/inventoryHelpers.js').then(
            ({ initializeQuestionForm }) => {
                initializeQuestionForm();
            },
        );
    }

    if (
        document.querySelector('[data-selector="wave-date-data"]') ||
        document.querySelector('[data-selector="calendar-data"]')
    ) {
        import('@/app/calendar/calendarSupport.js').then(
            ({ initializeCalendarSupport }) => {
                initializeCalendarSupport();
            },
        );
    }

    // Initialize workstation create wizard in backend.workstations.create
    if (document.getElementById('workstation-create-wizard')) {
        import('./workstationCreate.js').then(
            ({ initializeWorkstationCreateWizard }) => {
                initializeWorkstationCreateWizard();
            },
        );
    }

    // Initialize workstation create wizard in backend.workstations.create and installer.physical_inventory.workstations.create
    if (document.getElementById('flexplace')) {
        import('./workstationCreate.js').then(
            ({ changeWorkstationRequiredInputs }) => {
                document
                    .getElementById('flexplace')
                    .addEventListener('change', (event) =>
                        changeWorkstationRequiredInputs(event.target),
                    );
            },
        );
    }

    // initialize signaturePad
    if (document.getElementById('sign_form')) {
        const sign_form = document.getElementById('sign_form');

        import('@/support/initializeSignaturePad.js').then(
            ({ initializeSignaturePad, manageSignaturePostEvent }) => {
                const signature_pad = initializeSignaturePad(sign_form);

                sign_form.addEventListener('submit', function (event) {
                    manageSignaturePostEvent(sign_form, event, signature_pad);
                });
            },
        );
    }

    document.querySelectorAll('.copy-to-clipboard').forEach((element) => {
        element.addEventListener('click', function (event) {
            event.preventDefault();

            copyToClipboard(element);
        });
    });
}

function redirectFromLogin() {
    const redirectBody = document.getElementById('login-redirect-body');
    const redirectUrl = redirectBody.dataset?.targetUrl;

    if (!redirectUrl) {
        return;
    }

    window.location.assign(redirectUrl);
}

function setNewContainerParentFeedback(add_container_button_element) {
    var component_container_select = add_container_button_element
        .closest('form')
        .querySelector('.ant-select-selection-item');
    var component_container_select_input = add_container_button_element
        .closest('form')
        .querySelector('.component-container-select-input');

    var text_content = component_container_select
        ? component_container_select.textContent
        : '';

    var feedback =
        add_container_button_element.dataset.newNestedContainer + text_content;

    if (!component_container_select_input.value) {
        feedback = add_container_button_element.dataset.newContainer;
    }

    document.getElementById(
        'container-select-new-container-label',
    ).textContent = feedback;
}

function resetNewContainerInputs() {
    document
        .querySelectorAll('.mass-move-to-container-modal .alert')
        .forEach((alert) => alert.remove());

    var new_container_inputs = document.getElementById(
        'container-select-new-container',
    );

    if (!new_container_inputs) {
        return;
    }

    new_container_inputs.closest('form').reset();
    new_container_inputs.classList.add('d-none');

    document.getElementById('add_container_cancel').classList.add('d-none');

    document.getElementById('add_container_button').classList.remove('d-none');
    document.getElementById('add_container_button').disabled = false;

    var container_name_input = document.getElementById('container_name');
    container_name_input.value = '';
    container_name_input.required = false;

    document.getElementById('office_address_id').required = false;
    document.getElementById('location_id').required = false;
}

function disableNotSelectedChoices(input) {
    var parent_choice_id = input.name.replace('choice_', '');
    var value = input.value;

    var choices_higher = document.querySelector(
        'div[data-parent-choice-id="' + parent_choice_id + '"]',
    );
    var choices_deeper = document.querySelector(
        'div[data-parent-choice-id="' + value + '"]',
    );

    document
        .querySelectorAll(
            'input.component-choice-property-option[data-parent-choice-id="' +
                parent_choice_id +
                '"][id^="' +
                input.id +
                '"]',
        )
        .forEach((input) => {
            input.disabled = false;
            input.checked = false;
            input.required = true;
        });

    document
        .querySelectorAll(
            'input.component-choice-property-option[data-parent-choice-id="' +
                parent_choice_id +
                '"]:not([id^="' +
                input.id +
                '"])',
        )
        .forEach((input) => {
            input.disabled = true;
            input.checked = false;
            input.required = false;
        });

    if (choices_higher) {
        choices_higher
            .querySelectorAll(
                'input.component-choice-input[type=radio]:not([value="' +
                    value +
                    '"]):not([name="choice_' +
                    parent_choice_id +
                    '"])',
            )
            .forEach((input) => {
                input.checked = false;
                input.disabled = true;
            });
    }

    if (choices_deeper) {
        choices_deeper
            .querySelectorAll(
                'input.component-choice-input[type=radio][name="choice_' +
                    value +
                    '"]',
            )
            .forEach((input) => {
                input.checked = false;
                input.disabled = false;
                input.required = true;
            });

        choices_deeper
            .querySelectorAll(
                'input.component-choice-input[type=radio][name="choice_' +
                    value +
                    '"][data-has-no-sibling-with-component="true"',
            )
            .forEach((input) => {
                input.checked = true;
                input.disabled = false;
            });
    }
}

function showAjaxResponseIcon(
    input,
    location,
    icon_class,
    font_class,
    message = null,
) {
    var saved_icon = document.createElement('i');
    saved_icon.classList.add('la', icon_class);

    var saved_span = document.createElement('span');
    saved_span.classList.add(font_class);
    saved_span.append(saved_icon);

    if (message) {
        var message_span = document.createElement('span');
        message_span.classList.add('ml-1');
        message_span.textContent = message;
        saved_span.append(message_span);
    }

    input.parentNode.parentNode[location](saved_span);
    $(saved_span).fadeOut(message ? 6000 : 2000, function () {
        this.remove();
    });
}

function getPostCheckboxErrorMessage(response) {
    if (response.status === 422 && response.responseJSON?.errors) {
        return Object.values(response.responseJSON.errors)[0][0];
    }

    var status_message_key = 'general.error_' + response.status;

    return lang.has(status_message_key)
        ? lang.get(status_message_key)
        : lang.get('general.error_500');
}

function showMoveWorkstationSettingHelpText(interval_input) {
    var help_text_span = document.getElementById('interval_help_text');
    var value = parseInt(interval_input.value);

    if (value === 0) {
        help_text_span.innerText = lang.get('general.will_be_moved_directly');

        return;
    }

    import('@/app/calendar/dateFunctions').then(
        ({ addWorkingDays, getLocaleDay }) => {
            var next_working_day = getLocaleDay(addWorkingDays(new Date(), 1));
            var move_day = getLocaleDay(addWorkingDays(new Date(), value));

            help_text_span.innerText = lang.get(
                'general.selected_events_will_be_moved_move_day',
                {
                    next_working_day: next_working_day,
                    move_day: move_day,
                },
            );
        },
    );
}

function getElementToHideButtonsIn(form) {
    var hide_buttons = form;

    if (form.closest('[data-portlet]')) {
        hide_buttons = form
            .closest('[data-portlet]')
            .querySelector('[data-form-actions]');
    }

    if (form.querySelector('[data-portlet]')) {
        hide_buttons = form
            .querySelector('[data-portlet]')
            .querySelector('[data-form-actions]');
    }

    if (form.closest('.modal-dialog')) {
        hide_buttons = form.querySelector(
            '.modal-dialog:not(.d-none) .modal-footer:not(.d-none)',
        );
    }

    return hide_buttons;
}

function toggleShopwareFields() {
    const shopwareFields = document.querySelectorAll('.shopware-field'),
        enableShopware = document.getElementById('enable_shopware');

    if (enableShopware.checked) {
        shopwareFields.forEach((field) => {
            field.closest('.form-group').style.display = 'block';
            field.disabled = false;
        });
    } else {
        shopwareFields.forEach((field) => {
            field.closest('.form-group').style.display = 'none';
            field.disabled = true;
        });
    }
}

function filterPropertyTypeSelect(value) {
    let validation = '';

    switch (value) {
        case 'purchase_date':
        case 'date_time':
        case 'replacement_date':
        case 'time_period':
            validation = 'date_Ymd';
            break;
        case 'money':
            validation = 'money_euro_rule';
            break;
    }

    if (validation.length) {
        document
            .querySelectorAll("input[type='checkbox'][name^='validation']")
            .forEach(function (element) {
                element.setAttribute('disabled', true);
                element.removeAttribute('checked');
                if (element.name.includes(validation)) {
                    element.setAttribute('checked', 'checked');
                }
            });

        return;
    }

    if (value === 'default') {
        document
            .querySelectorAll("input[type='checkbox'][name^='validation']")
            .forEach(function (element) {
                element.removeAttribute('disabled');
            });

        return;
    }

    document
        .querySelectorAll("input[type='checkbox'][name^='validation']")
        .forEach(function (element) {
            element.removeAttribute('checked');
            element.removeAttribute('disabled');
        });
}

function copyToClipboard(element) {
    navigator.clipboard.writeText(element.dataset.text);

    element.querySelectorAll('[data-copy-state="copied"]').forEach((icon) => {
        icon.classList.remove('d-none');
    });

    element.querySelectorAll('[data-copy-state="idle"]').forEach((icon) => {
        icon.classList.add('d-none');
    });

    element.dataset.content = lang.get('general.copied_to_clipboard');

    $(element).popover('show');

    setTimeout(() => {
        element
            .querySelectorAll('[data-copy-state="copied"]')
            .forEach((icon) => {
                icon.classList.add('d-none');
            });

        element.querySelectorAll('[data-copy-state="idle"]').forEach((icon) => {
            icon.classList.remove('d-none');
        });

        element.dataset.content = lang.get('general.permanent_link');

        $(element).popover('hide');
    }, 1000);
}
